import { Observable } from 'rxjs/Observable'
import { orgId } from 'app/modules/org/selectors'
import { api } from './api'
import * as actions from './actions'

const fetchSegments = (action$, { getState }) => {
  return action$
    .ofType(actions.fetchSegments.toString())
    .pluck('payload')
    .mergeMap(({ id }) => {
      return api
        .fetchSegments(id, orgId(getState()))
        .map(response => actions.fetchSegmentsSuccess({ id, endUserSegments: response }))
        .startWith(actions.fetchSegmentsPending({ id }))
        .catch(error => {
          return Observable.of(actions.fetchSegmentsFailed({ id, error }))
        })
    })
}

export const epic = fetchSegments



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/segment/epic.js